import IdvVerified from './idv-verified';

export default IdvVerified;
